import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface EmailExistsDialogProps {
  open: boolean;
  onConfirm: () => void;
  email: string;
}

export function EmailExistsDialog({ open, onConfirm, email }: EmailExistsDialogProps) {
  return (
    <AlertDialog open={open}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>E-mail já cadastrado</AlertDialogTitle>
          <AlertDialogDescription className="space-y-2">
            <p>
              O e-mail <strong>{email}</strong> já está cadastrado no sistema.
            </p>
            <p>
              Por favor, utilize um e-mail diferente para criar esta tenant de demonstração.
            </p>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction onClick={onConfirm}>
            Alterar E-mail
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
